module.exports = __webpack_public_path__ + "static/media/friends-of-the-chester-valley-trail.f0614735.md";